import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, orderBy, collection, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase";
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
//page links   
//help
import { VscArrowLeft } from "react-icons/vsc";
import { IoIosHelpCircle, IoIosHelpCircleOutline } from "react-icons/io";
// Icons 
import { MdOutlinePayments } from "react-icons/md";
import { VscGitStashApply, VscChromeClose, VscSparkle, VscFeedback, VscDebugStackframe, VscCircleFilled, VscCode, VscDebugConsole, VscSymbolEvent } from "react-icons/vsc";
//old
import { GetAgoTime } from '../components/getAgoTime';
import { CiBookmark } from "react-icons/ci";
import { LuBriefcaseBusiness } from "react-icons/lu";
import { FaStar } from "react-icons/fa";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoDocumentTextOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
import { Incrementread } from './incrementread';
import './postread.css';
import Statusbar from '../master_root/statusbar';
export default function Postread({ data = {} }) {

  const [loading, setLoading] = useState(true);
  const [Skillscategories, setSkillscategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [Jobtasks, setJobtasks] = useState([]);
  const [CompanysUi, setCompanysUi] = useState([]);
  const [jobcategories, setJobcategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [experience, setExperience] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [loginName, setLoginName] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back
    } else {
      navigate('/'); // No history, go to home
    }
  };

  const [Pagetitle, setPagetitleData] = useState('Find the Right Job or Talent Faster');
  const [Pagedescription, setPagedescriptionData] = useState(
    'Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers.'
  );
  const [Pagekeywords, setPagekeywords] = useState('Find the Right Job or Talent Faster');

  const [user, setUser] = useState(null);
  //login
  const [userlogin, setuserlogin] = useState(false); // State for popup

  useEffect(() => {
    checkUserAuth(setUser);  // Auto-login
    const existingUser = Cookies.get("guid");   // Check for existing login

    if (existingUser != null) {
      setuserlogin(true);
      const photo = Cookies.get("login_photoURL");

      setPhotoURL(photo);
    } else {
      setuserlogin(false);   // Auto-open login popup if not logged in
    }
  }, []);


  useEffect(() => {
    const fetchJobtasks = async () => {
      try {
        const q = query(
          collection(db, "postdata"),
          where("visibility", "==", true),
          where("uid", "==", data.uid)
        );
        const querySnapshot = await getDocs(q);
        Incrementread(data.uid);
        // ✅ Move this outside the map, call only once

        // querySnapshot.forEach(async (docSnap) => {
        //   const postRef = doc(db, "postdata", docSnap.id);
        //   await updateDoc(postRef, {
        //     read: increment(1)
        //   });
        // });

        const JobtasksList = await Promise.all(
          querySnapshot.docs.map(async doc => {
            const jobData = { id: doc.id, ...doc.data() };

            // Fetch company
            const cq = query(
              collection(db, "companys"),
              where("uid", "==", jobData.companysuid),
              where("status", "==", true)
            );
            const companysSnapshot = await getDocs(cq);
            const companyData = companysSnapshot.docs.map(cdoc => ({
              id: cdoc.id,
              ...cdoc.data()
            }))[0];

            // ✅ Don't call setState here — gather everything first
            return {
              ...jobData,
              company: companyData || null
            };
          })
        );

        // ✅ Call setState after mapping is done
        if (JobtasksList.length > 0) {
          const firstTask = JobtasksList[0];
          setJobcategories(firstTask.jobcategories);
          setPagetitleData(firstTask.company.companyname + " | " + firstTask.jobcategories + " | " + firstTask.title);
          setPagedescriptionData(firstTask.keywords + ", " + firstTask.skills + ", " + firstTask.description);
          setPagekeywords(firstTask.keywords + ", " + firstTask.skills + ", " + firstTask.title + ", " + firstTask.company.companyname + ", " + firstTask.company.company_types + ", " + firstTask.company.industry);
        }

        setJobtasks(JobtasksList);
        setIsLoading(false);

      } catch (error) {
        console.error("Error fetching Jobtasks:", error);
        setIsLoading(false);
      }
    };

    fetchJobtasks();
  }, []);
  return (
    <div>
      <Statusbar data={'Read post'} />
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>{Pagetitle} | EditorTask - India`s Trusted Platform for Jobs & Creative Talent</title>

          <meta name="description" content={Pagedescription} />
          <meta
            name="keywords"
            content={`${Pagetitle + ", " + Pagedescription}, job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work`}
          />

          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent" />
          <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

        </Helmet>
        <br />
        <div className="container_size">
          <div>
            {isLoading ? (
              <Lodinging />
            ) : (
              Jobtasks.map((Jobtask, index) => (
                <div key={index}>
                  <img className='company-cover' src={Jobtask.company.cover}></img>
                </div>
              ))
            )}
          </div>

          <div className='post-container'>
            <div className='post_div'>


              <div className="Tasks-grid">
                {isLoading ? (
                  <Lodinging />
                ) : (
                  Jobtasks.map((Jobtask, index) => (
                    <div
                      key={index}
                      className="Tasks-items full"

                    >


                      {Jobtask.company && (
                        <div className="company-hiring" >

                          <div className='hir-div'>
                            <div className="title-text">{Jobtask.jobcategories}</div>

                            <div className='hir-info-div'>
                              <b className='company'>{Jobtask.company.companyname}</b>
                              <div className='items-box'>
                                <FaStar className='items-rating' />
                                <a className='reviews'>
                                  {Jobtask.company.rating + " | " + Jobtask.company.reviws + " reviews"}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className='hir-logo-div' onClick={() => navigate(`/${Jobtask.company.slug}`)}  >

                            <img
                              className="hir-logo-img"
                              src={Jobtask.company.logo}
                              alt="Logo"
                              onLoad={() => setLoading(false)}
                              onError={() => setLoading(false)} // also hides loader if there's an error
                              style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                            />
                          </div>
                        </div>
                      )}
                      <div className='job-info-body' >
                        <div className='job-info'>
                          <table className='experience-table'>
                            <tr><td>
                              <RiSlideshowLine className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='Jobtask-category-text'> {Jobtask.category.replace(/-/g, " ")}</a>
                              </td>
                            </tr>
                            <tr><td>
                              <LuBriefcaseBusiness className='job_biz_icon' />
                            </td>
                              <td>
                                <a> {Jobtask.experience}</a>
                              </td>
                            </tr>

                            <tr><td>
                              <MdOutlinePayments className='job_biz_icon' />
                            </td>
                              <td>
                                <a className="job_biz_text">
                                  {Jobtask.currency} <b>{Jobtask.budget}/- </b>{Jobtask.budgetpackage.replace(/-/g, " ")}
                                </a>
                              </td>
                            </tr>
                            <tr><td>
                              <CiLocationOn className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='job_biz_text'>{Jobtask.city + ", " + Jobtask.state + " - " + Jobtask.country}</a>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div className='job-info'>
                          <table className='experience-table'>
                            <tr><td>
                              <IoDocumentTextOutline className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='job_biz_text'> Greetings: {Jobtask.title}</a>
                              </td>
                            </tr>
                            <tr><td>
                              <BsPersonWorkspace className='job_biz_icon' />
                            </td>
                              <td>
                                <a className='job_biz_text'>{Jobtask.skills}</a>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                      <div className='job-save-div' >

                        <div className='date-lable'><b>{Jobtask.read} Read</b>, {GetAgoTime(Jobtask.date_time) + ", " +
                          Jobtask.date_time.toDate().toLocaleString('en-GB', {
                            day: 'numeric',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          }).toUpperCase()


                        }</div>
                        <div className='save_note'>
                          <CiBookmark className='save_icon' />

                          <div className='save_text'>Save</div>
                        </div>
                      </div>

                    </div>
                  ))
                )}
              </div>
              <br />
              <div className="button-div">
                <div className='button-ui3' onClick={handleGoBack}><VscChromeClose className='icon'></VscChromeClose> Cancel</div>
                <div className='button-ui' onClick={() => navigate(`/apply?uid=${data.uid}`)}><VscGitStashApply className='icon'></VscGitStashApply> Apply </div>
              </div>
              <div className="summary-div">
                {isLoading ? (
                  <Lodinging />
                ) : (
                  Jobtasks.map((Jobtask, index) => (
                    <div className="Tasks-items" key={index}>

                      <div className="header-lable">Job Description</div>
                      <br />
                      <div className="description-lable">{Jobtask.description}</div>
                      <br />
                      <div className='highlights-row'>
                        <div key={index} className="highlights-items">
                          <VscSymbolEvent className='icon' />
                          <div className="keys-lable">Highlights</div>
                        </div>
                      </div>

                      <div className='highlights-row'>
                        <div key={index} className="highlights-items">

                          <div className="highlights-lable">{Jobtask.title}</div>
                        </div>
                      </div>

                      <br />
                      <div className='highlights-row'>
                        <div key={index} className="highlights-items">
                          <VscCode className='icon' />
                          <div className="keys-lable">Skills</div>
                        </div>
                      </div>

                      <div className='highlights-row'>
                        {Jobtask.skills.split(',').map((item, index) => (
                          <div key={index} className="highlights-items">

                            <div className='highlights-lable'>
                              {item.trim()}
                            </div>,
                          </div>
                        ))}

                      </div>
                      <br />
                      <div className='highlights-row'>
                        <div key={index} className="highlights-items">
                          <VscDebugConsole className='icon' />
                          <div className="keys-lable">Keywords</div>
                        </div>
                      </div>
                      <div className='highlights-row'>
                        {Jobtask.keywords.split(',').map((item, index) => (
                          <div key={index} className="highlights-items">

                            <div className='highlights-lable'>
                              {item.trim()}
                            </div>,
                          </div>
                        ))}

                      </div>
                    </div>
                  ))
                )}
              </div>
              <br />

            </div>
            {/*<div className='post_updates'>
  <div className="summary-div">
  {isLoading ? (
    <Lodinging />
  ) : (
    Jobtasks.map((Jobtask, index) => (
      <div className="Tasks-items" key={index}>
       {Jobtask.company.companyname}
       
      
      </div>
    ))
  )}

     </div>
        </div> */}


          </div>
        </div>
      </div>
      <br /><br />
    </div>
  );
}
